import React, { useState, useEffect, useRef } from 'react';
import { Main, Axios } from '../../../Helpers/importacionesComunes'
import { useContextoGlobal } from '../../../Context/contextoGlobal';
import { Spinner, Typography } from '@material-tailwind/react';
import { Tabla } from '../componentes/Tabla'
import { Cabecera } from '../componentes/Cabecera'
import { AbmUsuario } from '../componentes/AbmUsuario'
import { SearchResultsCounter } from '../../ComponentesComunes/SearchResultsCounter';

export default function Usuarios({ match, history }) {
    const [registros, setRegistros] = useState([])
    const [registrosAmostrar, setRegistrosAmostrar] = useState([])
    const [cargandoRegistros, setCargandoRegistros] = useState(true);
    const { usuario } = useContextoGlobal();
    const [huboError, setHuboError] = useState(false)
    const [perfiles, setPerfiles] = useState([])
    const [regiones, setRegiones] = useState([])
    const [abmAbierto, setAbmAbierto] = useState(false)
    const [usuarioEditando, setUsuarioEditando] = useState(null)
    const filtrosRef = useRef()

    useEffect(() => {
        if (usuario) {
            buscarDatos({ conLoading: true })
            buscarTablasGenerales()
        }
    }, [usuario])

    useEffect(() => {
        setRegistrosAmostrar(registros)
    }, [registros])

    const buscarDatos = async (params = {}) => {
        const { conLoading } = params

        setHuboError(false)
        setRegistros([])
        conLoading && setCargandoRegistros(true)
        try {
            const { data } = await Axios.get('/api/tablasgenerales/usuarios')
            setRegistros(Array.isArray(data) ? data : [])
            conLoading && setCargandoRegistros(false)
        } catch (err) {
            console.log(err)
            setHuboError(true)
            conLoading && setCargandoRegistros(false)
        }
    }

    const buscarTablasGenerales = async () => {
        try {
            const { data } = await Axios.get('/api/tablasgenerales/regiones')
            setRegiones(Array.isArray(data) ? data.filter(item => item.id_region > 0) : [])
        } catch (err) {
            console.log('No se pudieron cargar las regiones', err)
        }

        try {
            const { data } = await Axios.get('/api/tablasgenerales/usuarios/perfiles')
            setPerfiles(Array.isArray(data) ? data : [])
        } catch (err) {
            console.log('Perfiles de usuario no disponibles todavía', err?.response?.status)
        }
    }

    const filtrarLista = (filterCallback) => {
        filtrosRef.current = filterCallback
        setRegistrosAmostrar(registros.filter(filterCallback))
    }

    const resetearLista = () => {
        filtrosRef.current = null
        setRegistrosAmostrar(registros)
    }

    const abrirAlta = () => {
        setUsuarioEditando(null)
        setAbmAbierto(true)
    }

    const abrirEdicion = (item) => {
        setUsuarioEditando(item?.id_usuario ?? null)
        setAbmAbierto(true)
    }

    const cerrarAbm = () => {
        setAbmAbierto(false)
        setUsuarioEditando(null)
    }

    if (huboError) {
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <span>Se produjo un error al cargar los datos para esta vista</span>
            </div>
        </Main>
    }

    if (cargandoRegistros || !usuario) {
        return <Main center alinear>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando registros...</span>
            </div>
        </Main>
    }

    return (
        <div className='flex w-full min-w-0 overflow-x-hidden'>
            <div className="w-full min-w-0 bg-blue lg:!m-6 xl:!m-6 items-center flex flex-col justify-center">
                <Typography variant="h4" color="blue-gray" className="font-bold mb-4 text-center px-4">
                    Usuarios
                </Typography>

                <div className='w-full min-w-0 mb-4 px-4 lg:px-0'>
                    <Cabecera
                        filtrarLista={filtrarLista}
                        resetearLista={resetearLista}
                        perfiles={perfiles}
                        regiones={regiones}
                    />
                </div>

                {registrosAmostrar.length > 0 && <SearchResultsCounter count={registrosAmostrar.length} badgeLabel="Usuarios" />}

                <div className='w-full min-w-0 px-4 lg:px-0'>
                <Tabla
                    registrosAmostrar={registrosAmostrar}
                    reinicializar={() => buscarDatos()}
                    onCrearUsuario={abrirAlta}
                    onEditarUsuario={abrirEdicion}
                />
                </div>

                <AbmUsuario
                    open={abmAbierto}
                    idUsuario={usuarioEditando}
                    perfiles={perfiles}
                    regiones={regiones}
                    onCerrar={cerrarAbm}
                    onGuardado={() => buscarDatos()}
                />
            </div>
        </div>
    )
}
